//全局变量

export default {
  // 请求成功返回码
  SucessRequstCode:0,

  // token无效标记
  TokenInvalidFlag : 0
}
